import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';

export type BookingSectionFormGroup = FormGroup<{
  selectedDate: FormControl<string>;
  selectedSlot: FormControl<string>;
}>;

export type CompanySectionFormGroup = FormGroup<{
  ContactName: FormControl<string>;
  DisplayName: FormControl<string>;
  LegalName: FormControl<string>;
  ContactEmail: FormControl<string>;
}>;

export type BillingSectionFormGroup = FormGroup<{
  BillingBusinessName: FormControl<string>;
  BillingContactName: FormControl<string>;
  BillingContactEmail: FormControl<string>;
  BillingContactPhone: FormControl<string>;
  BillingAddress1: FormControl<string>;
  BillingAddress2: FormControl<string>;
  BillingCity: FormControl<string>;
  BillingState: FormControl<string>;
  BillingZipCode: FormControl<string>;
  BillingCountry: FormControl<string>;
}>;

export type ShippingSectionFormGroup = FormGroup<{
  sameAsBilling: FormControl<boolean>;
  ShippingBusinessName: FormControl<string>;
  ShippingContactName: FormControl<string>;
  ShippingContactEmail: FormControl<string>;
  ShippingContactPhone: FormControl<string>;
  ShippingAddress1: FormControl<string>;
  ShippingAddress2: FormControl<string>;
  ShippingCity: FormControl<string>;
  ShippingState: FormControl<string>;
  ShippingZipCode: FormControl<string>;
  ShippingCountry: FormControl<string>;
}>;

export type OnboardingBookingFormGroup = FormGroup<{
  booking: BookingSectionFormGroup;
  company: CompanySectionFormGroup;
  billing: BillingSectionFormGroup;
  shipping: ShippingSectionFormGroup;
  honeypot: FormControl<string>;
}>;

export function createOnboardingBookingForm(fb: NonNullableFormBuilder): OnboardingBookingFormGroup {
  return fb.group({
    booking: fb.group({
      selectedDate: fb.control('', Validators.required),
      selectedSlot: fb.control({ value: '', disabled: true }, Validators.required)
    }),
    company: fb.group({
      ContactName: fb.control('', Validators.required),
      DisplayName: fb.control('', Validators.required),
      LegalName: fb.control('', Validators.required),
      ContactEmail: fb.control('', [Validators.required, Validators.email])
    }),
    billing: fb.group({
      BillingBusinessName: fb.control('', Validators.required),
      BillingContactName: fb.control('', Validators.required),
      BillingContactEmail: fb.control('', [Validators.required, Validators.email]),
      BillingContactPhone: fb.control('', Validators.required),
      BillingAddress1: fb.control('', Validators.required),
      BillingAddress2: fb.control(''),
      BillingCity: fb.control('', Validators.required),
      BillingState: fb.control('', Validators.required),
      BillingZipCode: fb.control('', Validators.required),
      BillingCountry: fb.control('US', Validators.required)
    }),
    shipping: fb.group({
      sameAsBilling: fb.control(true),
      ShippingBusinessName: fb.control('', Validators.required),
      ShippingContactName: fb.control('', Validators.required),
      ShippingContactEmail: fb.control('', [Validators.required, Validators.email]),
      ShippingContactPhone: fb.control('', Validators.required),
      ShippingAddress1: fb.control('', Validators.required),
      ShippingAddress2: fb.control(''),
      ShippingCity: fb.control('', Validators.required),
      ShippingState: fb.control('', Validators.required),
      ShippingZipCode: fb.control('', Validators.required),
      ShippingCountry: fb.control('US', Validators.required)
    }),
    honeypot: fb.control('')
  });
}

export function copyBillingToShipping(form: OnboardingBookingFormGroup): void {
  const billing = form.controls.billing.controls;
  const shipping = form.controls.shipping.controls;

  shipping.ShippingBusinessName.setValue(billing.BillingBusinessName.value);
  shipping.ShippingContactName.setValue(billing.BillingContactName.value);
  shipping.ShippingContactEmail.setValue(billing.BillingContactEmail.value);
  shipping.ShippingContactPhone.setValue(billing.BillingContactPhone.value);
  shipping.ShippingAddress1.setValue(billing.BillingAddress1.value);
  shipping.ShippingAddress2.setValue(billing.BillingAddress2.value);
  shipping.ShippingCity.setValue(billing.BillingCity.value);
  shipping.ShippingState.setValue(billing.BillingState.value);
  shipping.ShippingZipCode.setValue(billing.BillingZipCode.value);
  shipping.ShippingCountry.setValue(billing.BillingCountry.value);
}
